import * as React from 'react';
import './Value.css'

import * as _ from 'lodash'
import classNames from 'classnames'
import { html as beautify_html } from 'js-beautify'

import stringify from '../stringify'
import Diagram from './Diagram'
import { Cursor, CursorV } from '../lib/Cursor';
// import { runDefinition } from '../evaluate'
import * as Model from '../types/document'
import Sticky from 'src/view/Sticky';
import WithContextMenu from 'src/view/WithContextMenu';
import * as actions from '../actions'
import { documentC } from 'src/globals';
import { runOnNode } from 'src/model/evaluate';
import { Stack } from 'src/types/stack';
import { NetworkUser } from 'golgi';


// import Diagram from './Diagram'

function replacer (key: string, value: any) {
  if (value && value.toFixed) { return Number(value.toFixed(3)); }
  if (value instanceof Error) { return "ERROR: " + value.message; }
  return value
}

class Value extends React.Component<{
  value: any,
  onMouseOver?: () => void,
  onElementMouseOver?: (index: number | string) => void,
  top?: boolean,
  blockC: Cursor<Model.Block>,
  nodeId?: Model.NodeId,
  stack: Stack,
  activeIndex?: number | string,
  orientation: 'h' | 'v',
  path?: Array<string | number>
}> {
  static defaultProps = {
    orientation: 'v',
  }

  render() { return <NetworkUser debugName="Value" props={this.props} state={this.state} render={() => {
    const { onMouseOver, top, path, blockC, nodeId } = this.props

    let toReturn = <div className={classNames("Value", {"Value-top": top})} onMouseOver={onMouseOver}>
      {this.renderInsides()}
    </div>

    if (nodeId && path && path.length > 0) {
      const joinedPath = '.' + path.join('.')
      toReturn = (
        <WithContextMenu menuMaker={() => (console.log("menumaker"), [
          {type: 'heading', heading: "VALUE"},
          {
            type: 'contents',
            contents: <React.Fragment>
              Extract <span style={{fontFamily: "monospace"}}>{joinedPath}</span>
            </React.Fragment>,
            onClick: () => actions.act(() => {
              actions.addCodeCallFrom(blockC, nodeId, (inputNodeId) => inputNodeId + joinedPath)
            })
          }
        ])}>
          {toReturn}
        </WithContextMenu>
      )
    }

    return toReturn
  }}/>}

  renderInsides() {
    let { value, path, nodeId, stack } = this.props
    const { blockC, top, orientation, activeIndex, onElementMouseOver } = this.props

    // TODO: visualize nodes without IDs? meh I'd rather get rid of such atrocities
    // TODO: visualize lower paths?
    let activeVisualizationC = undefined as CursorV<Model.Definition> | undefined
    if (top && nodeId) {
      for (let definitionC of CursorV.elemsKeyed(documentC._('definitions').fetch(), 'id')) {
        // TODO: don't run visualizations on themselves
        if (definitionC.value().isVisualization) {
          const result = runOnNode(nodeId, definitionC.unfetch(), stack)
          if (result.type === 'value' && result.value) {
            activeVisualizationC = definitionC 
            value = result.value
            break
          }
        }
      }
    }
  
    if (value instanceof Function) {
      return "ƒ"
    } else if (value instanceof Array && value.length > 0) {
      const rowCount = value[0] instanceof Object ? 3 : 6
      return <div className={"Value-array Value-array-orientation-" + orientation}>
        {value.map((element, i) => {
          const row = i % rowCount  + 1
          const col = Math.floor(i / rowCount) + 1
          return <React.Fragment key={i}>
              <div className={classNames("Value-array-index", {"Value-array-index-active": activeIndex === i, "Value-array-index-first-column": col === 1})}
                   onMouseOver={onElementMouseOver && (() => {console.log('onElementMouseOver', i); onElementMouseOver(i)})}
                   style={{gridRow: row, gridColumn: col * 2 - 1}}>
                <Sticky className="Value-label" title={`${i} / ${value.length}`}>
                  {i}
                </Sticky>
              </div>
              <div className={classNames("Value-array-element", {"Value-array-element-active": activeIndex === i})}
                   style={{gridRow: row, gridColumn: col * 2}}>
                <Value value={element} orientation={this.flippedOrientation()}
                       onMouseOver={onElementMouseOver && (() => {console.log('onElementMouseOver', i); onElementMouseOver(i)})}
                       blockC={blockC} nodeId={nodeId} stack={stack}
                       path={path && [...path, i]}
                />
              </div>
            </React.Fragment>
        })}
      </div>
    } else if (value instanceof HTMLElement) {
      const wrapper = document.createElement('div');
      wrapper.appendChild(value.cloneNode(true));
      return <pre>{beautify_html(wrapper.innerHTML)}</pre>
    } else if (value && value.isDiagram) {
      return <div className="Value-diagram">
        <Diagram width={130} height={130} diagram={value} />
      </div>
    } else if (value instanceof Object && _.size(value) > 0) {
      return <div className="Value-object">
        {_.map(_.toPairs(value), ([key, element], i) =>
          <React.Fragment key={key}>
            <div className={classNames("Value-object-key", {"Value-object-key-active": activeIndex === key})}
                 onMouseOver={onElementMouseOver && (() => {console.log('onElementMouseOver', key); onElementMouseOver(key)})} >
              <Sticky className="Value-label">
                {key}
              </Sticky>
            </div>
            <div className={classNames("Value-object-element-cell", {"Value-object-element-cell-active": activeIndex === key})}>
              <div className="Value-object-element">
                <Value value={element} orientation={orientation}
                       onMouseOver={onElementMouseOver && (() => {console.log('onElementMouseOver', key); onElementMouseOver(key)})}
                       blockC={blockC} nodeId={nodeId} stack={stack}
                       path={path && [...path, key]}
                />
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    } else if (typeof value === 'string') {
      return <div className={classNames("Value-basic", "Value-string", {"Value-string-big": value.length > 20 })}>
        <span className="Value-string-icon">❛</span><pre>{value}</pre>
      </div>
    } else {
      try {
        return <div className="Value-basic"><pre>{stringify(value, {replacer, maxLength: 20})}</pre></div>
      } catch (e) {
        return "Problem: " + e.message  // TODO: blah
      }
    }
  }

  flippedOrientation(): 'h' | 'v' {
    if (this.props.orientation == 'h') {
      return 'v'
    } else {
      return 'h'
    }
  }
}

export default Value



// WEBPACK FOOTER //
// ./src/view/Value.tsx